/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';
import { Form, Field } from 'react-final-form';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import classNames from 'classnames';
import { FieldTextInput, PrimaryButton } from '..';
import css from '../FieldPromoCode/FieldPromoCode.module.css';

const PromoCodeField = ({ className, intl, onApply, promoCodeApplied, promoCodeError }) => {
  const [isFieldVisible, setIsFieldVisible] = useState(false);
  const [isApplying, setIsApplying] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);

  const handleApplyPromoCode = async promoCode => {
    if (!promoCode) {
      return;
    }

    setIsApplying(true);
    setHasApplied(false);

    try {
      await onApply(promoCode);
      setHasApplied(true);
    } catch {
      setHasApplied(false);
    } finally {
      setIsApplying(false);
    }
  };

  const errorMessage = promoCodeError || intl.formatMessage({ id: 'PromoCode.invalidPromoCode' });

  const buttonLabel =
    hasApplied && promoCodeApplied
      ? intl.formatMessage({ id: 'PromoCode.applied' })
      : intl.formatMessage({ id: 'PromoCode.apply' });

  return (
    <Form
      onSubmit={() => undefined}
      render={({ values }) => (
        <div className={classNames(css.root, className)}>
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              setIsFieldVisible(!isFieldVisible);
            }}
            className={css.headerLink}
          >
            <FormattedMessage id="PromoCode.headerLink" />
          </a>

          {isFieldVisible ? (
            <div className={css.inputWrapper}>
              <Field name="promoCode">
                {({ input }) => (
                  <FieldTextInput
                    {...input}
                    type="text"
                    name="promoCode"
                    placeholder="Promotional code"
                    customErrorText={promoCodeError ? errorMessage : ''}
                    customSuccessText={
                      hasApplied && promoCodeApplied
                        ? intl.formatMessage({ id: 'PromoCode.appliedPromoCode' })
                        : ''
                    }
                    onChange={event => {
                      input.onChange(event);
                      setHasApplied(false);
                    }}
                  />
                )}
              </Field>

              <PrimaryButton
                disabled={!values.promoCode}
                inProgress={isApplying}
                isSmall
                className={css.applyButton}
                type="button"
                onClick={() => handleApplyPromoCode(values.promoCode)}
              >
                {buttonLabel}
              </PrimaryButton>
            </div>
          ) : null}
        </div>
      )}
    />
  );
};

PromoCodeField.defaultProps = {
  className: null,
  promoCodeApplied: false,
  promoCodeError: null,
};

PromoCodeField.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  onApply: func.isRequired,
  promoCodeApplied: bool,
  promoCodeError: string,
};

export default injectIntl(PromoCodeField);
